package ai.jessie.web.pages.organisations

import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import ai.jessie.web.projects.unavailableProjectProblem
import ai.jessie.web.projects.validProjectId
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

// UC-010 A1–A4, A8 and A9. An invalid project ID sends no request and shows the same neutral
// absence as a project outside the organisation (A13).
@Page("{organisationId}/projects/{projectId}")
@Composable
fun organisationProjectPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    val projectId = ctx.route.dynamicParams["projectId"].orEmpty()
    when {
        !validOrganisationId(organisationId) ->
            projectProblemFrame(organisationId, organisationRequiredProblem())
        !validProjectId(projectId) ->
            projectProblemFrame(organisationId, unavailableProjectProblem())
        else -> key(organisationId, projectId) { projectsContent(organisationId, projectId) }
    }
}
